var LIB_PREFIX = 'f251c210-e7c9-42fa-bae3-b9352ec3722a'

try {
  window.postMessage = function (data) {
    window.ReactNativeWebView && window.ReactNativeWebView.postMessage(data)
  }
} catch (e) {
}

function stringify (type, payload, meta) {
  return LIB_PREFIX + JSON.stringify({
    type: type,
    payload: payload,
    meta: meta,
  })
}

function sendToRemote (data) {
  if (window.postMessage.length === 2) {
    requestAnimationFrame(function () {
      sendToRemote(data);
    });
  } else {
    window.postMessage(data);
  }
}

export const sendJSON = (json) => {
  sendToRemote(stringify('json', json));
}

 